import { render, staticRenderFns } from "./ConsultBtn.vue?vue&type=template&id=2cf836c9&scoped=true&"
import script from "./ConsultBtn.vue?vue&type=script&lang=js&"
export * from "./ConsultBtn.vue?vue&type=script&lang=js&"
import style0 from "./ConsultBtn.vue?vue&type=style&index=0&id=2cf836c9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../src/h5-coursePage/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf836c9",
  null
  
)

export default component.exports